import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { fetchFooterData } from '../../utils/apiService';

const Footer = () => {
    const [footerData, setFooterData] = useState(null);

    useEffect(() => {
        const getFooterData = async () => {
            const result = await fetchFooterData();
            if (result && result.status) {
                setFooterData(result.data);
            }
        };
        getFooterData();
    }, []);

    if (!footerData) return <div style={{ minHeight: '100px' }}></div>; // Placeholder while loading

    return (
        <footer className="footer" id="footer">
            <div className="mask mask-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="800" height="800" fill="none">
                    <circle cx="400" cy="400" r="325" stroke="url(#a6)" strokeWidth="150" />
                    <defs>
                        <linearGradient id="a6" x1="176" x2="569" y1="70.5" y2="674">
                            <stop offset="0" stopColor="#fff" stopOpacity="0.05" />
                            <stop offset="1" stopColor="#fff" stopOpacity="0" />
                        </linearGradient>
                    </defs>
                </svg>
            </div>
            <div className="mask mask-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="800" height="800" fill="none">
                    <circle cx="400" cy="400" r="325" stroke="url(#a7)" strokeWidth="150" />
                    <defs>
                        <linearGradient id="a7" x1="176" x2="569" y1="70.5" y2="674">
                            <stop offset="0" stopColor="#fff" stopOpacity="0.05" />
                            <stop offset="1" stopColor="#fff" stopOpacity="0" />
                        </linearGradient>
                    </defs>
                </svg>
            </div>
            <div className="footer-inner position-relative">
                <div className="footer-top">
                    <div className="tf-marquee">
                        <div className="marquee-wrapper">
                            <div className="initial-child-container">
                                {[...Array(20)].map((_, i) => (
                                    <div className="big-text" key={i}>
                                        Get In Touch <span className="text-stroke">Contact Us</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="tf-container">
                    <div className="footer-middle flex justify-content-between ">
                        <div className="left">

                            <div className="footer-logo">
                                <div className="title fs-32 fw-7">
                                    <Link to="/">
                                        <img src={footerData.logo} alt={footerData.company_name} />
                                    </Link>
                                </div>

                                <div className="desc lh-30 footer-text">
                                    <p>{footerData.about_text}</p>
                                </div>
                                <div className="social-links flex align-items-center g-20 mt-20">
                                    {footerData.fb_link && (
                                        <a href={footerData.fb_link} target="_blank" rel="noopener noreferrer">
                                            <i className="icon-fb"></i>
                                        </a>
                                    )}
                                    {footerData.x_link && (
                                        <a href={footerData.x_link} target="_blank" rel="noopener noreferrer">
                                            <i className="icon-X"></i>
                                        </a>
                                    )}
                                    {footerData.linkedin_link && (
                                        <a href={footerData.linkedin_link} target="_blank" rel="noopener noreferrer">
                                            <i className="icon-linkedin"></i>
                                        </a>
                                    )}
                                    {footerData.instagram_link && (
                                        <a href={footerData.instagram_link} target="_blank" rel="noopener noreferrer">
                                            <i className="icon-instagram"></i>
                                        </a>
                                    )}
                                    {footerData.tiktok_link && (
                                        <a href={footerData.tiktok_link} target="_blank" rel="noopener noreferrer">
                                            <i className="fab fa-tiktok"></i>
                                        </a>
                                    )}
                                </div>
                            </div>


                        </div>

                        <div className="footer-content footer-col-block">
                            <div className="title-mobile body-2">
                                Services
                                <i className="icon-angle-down"></i>
                            </div>
                            <div
                                className="tf-collapse-content"
                                style={{ display: 'unset' }}
                                dangerouslySetInnerHTML={{
                                    __html: `<ul>
                                        <li class="support-item-footer"><a href="#">Web Development</a></li>
                                        <li class="support-item-footer"><a href="#">Mobile App Development</a></li>
                                        <li class="support-item-footer"><a href="#">Domain and Hosting</a></li>
                                        <li class="support-item-footer"><a href="#">General IT Consultations</a></li>
                                    </ul>`
                                }}
                            />
                        </div>

                        <div className="locations-contact">
                            <div className="locations-footer item mb-30">
                                <div className="title body-2 fw-5">
                                    Locations
                                </div>
                                <div className="address body-2 lh-30">
                                    {footerData.address}.
                                </div>
                            </div>
                            <div className="contact-footer item">
                                <div className="title body-2 fw-5">
                                    Contact
                                </div>
                                <div>
                                    <h6>
                                        <a href={`mailto:${footerData.email}`} className="fw-5">{footerData.email}</a>
                                    </h6>
                                    <h4 className="lh-45 fw-6">
                                        <a href={`tel:${footerData.phone}`} className="mb-0">{footerData.phone}</a>
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tf-container">
                    <div className="footer-bottom">
                        <div className="line"></div>
                        <a href="#" className="footer-go-top">
                            <i className="icon-arrow-up"></i>
                        </a>
                        <div className="list-bottom flex align-items-center justify-content-between flex-wrap rg-15 g-30">
                            <span className="text-center lh-30">
                                © {new Date().getFullYear()} <Link to="#" className="fw-7">{footerData.company_name}</Link> - {footerData.website_name}. All rights reserved.
                            </span>
                            <ul className="flex align-items-center justify-content-center flex-wrap rg-15">
                                <li><Link to="/">Home</Link></li>
                                <li><Link to="/" state={{ scrollTo: 'about' }}>About</Link></li>
                                <li><Link to="/services">Services</Link></li>
                                <li><Link to="/contact">Contact</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
